export const BOARD_AUTH_TYPE = {
  READ_ALL: 101,
  PRIVATE: 102,
  READ_FAVORITE: 103,
  READ_FANCLUB: 104,
  READ_CLUBBJ: 105,
  READ_MANAGER: 106,
  READ_SUBSCRIPTION: 107,
} as const;

export const MENU_DISPLAY_TYPE = {
  GUEST: 101,
  SCHEDULE: 102,
  PHOTO: 103,
  NORMAL: 104,
  UCC: 105,
  UCC_LIST: 115,
  LINE: 106,
  TITLE: 107,
  REVIEW: 108,
  HIGHLIGHT: 109,
  EDITOR: 105,
  PARENT_COMMENT: 203,
  CHILD_COMMENT: 204,
  LIKE: 205,
  REPORT: 206,
  INSTAGRAM: 900,
  YOUTUBE: 901,
  BJSUPPORT: 112,
} as const;

export const PHP_STATION_ERROR_CODE = {
  USER_ALREADY_BLACKLISTED: 1300, // 로그인 한 사람이 방송국의 블랙리스트에 추가됨
  USER_ACCOUNT_SLEEP: 9002, // 휴면 계정 방송국 접근
  STATION_ACCOUNT_BANNED: 9100, // 계정 정지 방송국
  STATION_NOT_FOUND: 9000, // 방송국 없음
  STATION_BLINDED: 9001, // 블라인드 계정 방송국 접근
} as const;

export const PHP_STATION_ERROR_CODE_VALUE = Object.values(
  PHP_STATION_ERROR_CODE,
);

export const NODE_STATION_ERROR_CODE = {
  USER_ALREADY_BLACKLISTED: 'CHA1002', // 로그인 한 사람이 방송국의 블랙리스트에 추가됨
  USER_ACCOUNT_SLEEP: 'CHA1001', // 휴면 계정 방송국 접근
  STATION_ACCOUNT_BANNED: 'CHA1000', // 계정 정지 방송국
  STATION_NOT_FOUND: 'CHA1004', // 방송국 없음 & 블라인드 계정 방송국 접근
  SUSPENDED_USER: 'CHA1003', // 로그인 한 사람이 SOOP 에서 이용 정지된 사용자
} as const;

export const NODE_STATION_ERROR_CODE_VALUE = Object.values(
  NODE_STATION_ERROR_CODE,
);
